module.exports = __webpack_public_path__ + "img/4.a529235a.svg";